import { isObject, includes, isFunction } from 'lodash-es'
import { actionsBlacklist } from '.'

const { Sentry } = window
const isSentryEnabled =
  isObject(Sentry) && 'captureException' in Sentry && 'withScope' in Sentry

const createSentryMiddleware = () => (next) => (action) => {
  if (!isSentryEnabled) {
    return next(action)
  }

  if (!includes(actionsBlacklist, action.type)) {
    Sentry.addBreadcrumb({
      category: 'redux-action',
      message: action.type,
      level: 'info',
    })
  }

  try {
    return next(action)
  } catch (error) {
    Sentry.captureException(error)
  }

  return undefined
}

const sentryReportError = (error, errorInfo = {}) => {
  if (!isSentryEnabled) {
    return
  }

  Sentry.withScope((scope) => {
    if (isObject(errorInfo)) {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key])
      })
    }

    Sentry.captureException(error)
  })
}

const sentrySendDebugReport = (message = 'Debug', info = []) => {
  if (!isSentryEnabled) {
    return
  }

  Sentry.withScope((scope) => {
    info.forEach((item) => {
      scope.setExtra(...item)
    })

    scope.setLevel(Sentry.Severity.Debug)
    Sentry.captureMessage(message)
  })
}

const sentryConfigureGlobalScope = (callback) => {
  if (!isSentryEnabled || !isFunction(callback)) {
    return
  }

  Sentry.configureScope(callback)
}

const sentryMiddleware = isSentryEnabled ? createSentryMiddleware : undefined

export {
  sentryReportError,
  sentrySendDebugReport,
  sentryMiddleware,
  sentryConfigureGlobalScope,
}
